var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('Top',{attrs:{"id":"top"}}),_c('About',{attrs:{"id":"about"}}),_c('Feature',{attrs:{"id":"feature"}}),_c('Customer',{attrs:{"id":"customer"}}),_c('Step',{attrs:{"id":"step"}}),_c('FQA',{attrs:{"id":"faq"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }